import auth0 from 'auth0-js';
import axios from 'axios';
import {SERVER_URL, LOCAL_URL}  from './Constants';
import Cookies from 'universal-cookie';
import {Event} from './UseGATracker';



class Auth {
  constructor() {
    this.auth0 = new auth0.WebAuth({
      // the following three lines MUST be updated
      domain: 'bounte.auth0.com',
      audience: 'https://bounteapp.com', //API Audience  https://bounte.auth0.com/userinfo',
      clientID: 'Tf3IWtq1vTomIKP1U1g4V5bTw164uh6z',
      redirectUri: `${LOCAL_URL}/callback`,
      responseType: 'token id_token',
      scope: 'openid profile email',
      securityGroup:'',
      userData:{},
      defaultVenue:{},
      mappedVenues:{},
      //useRefreshTokens: true,
      onSessionUpdated : null,
      //cacheLocation: 'localstorage'
      lfReadOnly:false,
      ptReadOnly:false,
     
    });

    this.getProfile = this.getProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);


    this.venueId = '';
   
  }

  userData() {
    return this.userData;
  }

  getProfile() {
    return this.profile;
  }

  getIdToken() {
    //return this.idToken;
    return this.accessToken;
  }
  getAccessToken() {
    return this.accessToken;
  }
  getActiveVenuedId(){
    return this.venueId;
  }
  isAuthenticated() {
    
    return new Date().getTime() < this.expiresAt;
  }
  getSecurityGroup() {
    return this.securityGroup;
  }
  getLFReadOnly() {
    return this.lfReadOnly;
  }
  getPTReadOnly() {
    return this.ptReadOnly;
  }

  setActiveVenueId(id){
    this.venueId= id;
    for (var i =0; i<this.mappedVenues.length; i++){
      if (this.mappedVenues[i].objectId===id){
        this.defaultVenue = this.mappedVenues[i];
        //console.log("Found Default:" + this.defaultVenue);
        break;
      }
    }
  }
  getMappedVenues(){
    return this.mappedVenues;
  }

  signIn() {
    this.auth0.authorize();
  }

 


getDefaultVenue(){
  return this.defaultVenue;
}
  async handleAuthentication() {
    return new Promise( (resolve, reject) => {
      this.auth0.parseHash( async(err, authResult) => {
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }

        

      
         await this.setSession(authResult);
        resolve();
      });
    })
  }

  async setSession(authResult) {

    
    this.idToken = authResult.idToken;
    

    this.profile = authResult.idTokenPayload;
    this.accessToken = authResult.accessToken;
   
    //console.log(authResult.accessToken);

    // set the time that the id token will expire at
    //this.expiresAt = authResult.idTokenPayload.exp * 1000;
    var nowDate = new Date();
    this.expiresAt = new Date(nowDate.getTime() + (1000 * authResult.expiresIn));
    console.log('Expires at: ' + this.expiresAt);

    //console.log(this.profile);
    // call me on the server , set venueId
       //const venue = (await axios.get('http://localhost:5000/venue')).data;
      var venueUser = (await axios.get(`${SERVER_URL}/me`,
            {headers: { 'Authorization': `Bearer ${auth0Client.getAccessToken()}` }})).data;
      if (venueUser){
        Event("LOG", "User: " + venueUser.id , "LOGIN");
        // console.log(venueUser);
           // No venue!?  oh that wont work!
          if (venueUser.venues.length===0){
            alert('no valid venue id');
          
           this.signOut();
           this.signIn()
          }else{

            //  check if there was a cookie set for the login venue, if supporting two venues
            const cookies = new Cookies();
            const defaultVenueId= cookies.get('defaultVenueId');
            // check if the user has this venue mapped to their account.  Sometimes people can change cookies and auto-log in just on the client.
            // the server will check if the user is mapped.
            if (defaultVenueId){
              //console.log('found a default venue');
                // get the venue ID
                this.venueId = defaultVenueId;
                // loop through and set the deaultVenueObject
                if (venueUser.mappedVenues.length > 1){
                  for (var i =0; i<venueUser.mappedVenues.length; i++){
                    if (venueUser.mappedVenues[i].objectId===defaultVenueId){
                      this.defaultVenue = venueUser.mappedVenues[i];
                      //console.log("Found Default:" + this.defaultVenue);
                      //break;
                    }
                }
              }else{
                this.venueId = venueUser.venues[0].venueId;
                this.defaultVenue = venueUser.defaultVenue;
                cookies.set('defaultVenueId', this.venueId, { path: '/' });
              }
                
            }else  {
                this.venueId = venueUser.venues[0].venueId;
                this.defaultVenue = venueUser.defaultVenue;
                cookies.set('defaultVenueId', this.venueId, { path: '/' });
            }
           // console.log('*** Default venue ID :' + defaultVenueId);
             // get the venue ID
            //this.venueId = venueUser.venues[0].venueId;
            this.mappedVenues = venueUser.mappedVenues;
            this.securityGroup = venueUser.securityGroup;
            this.userData = venueUser;
            this.lfReadOnly=venueUser.lfReadOnly;
            this.ptReadOnly=venueUser.ptReadOnly;
            //this.onVenueUpdated(this.defaultVenue)
            //this.defaultVenue = venueUser.defaultVenue
            //console.log( 'default' + venueUser.defaultVenue)
           /* this.venue = (await axios.get(`${SERVER_URL}/venue/` +  auth0Client.getActiveVenuedId(),{
              headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
            })).data;
            console.log( this.venue);*/
          }
          //console.log(venueUser);
          if (this.onSessionUpdated){this.onSessionUpdated()}
          return true;
      }
      

     
  }

  signOut() {
    this.expiresAt = undefined;
    this.auth0.logout({
      returnTo: `${LOCAL_URL}`,
      clientID: 'Tf3IWtq1vTomIKP1U1g4V5bTw164uh6z',
    });
  }

   async silentAuth() {
    
   //  console.log('********** silent auth');
    return new Promise(async(resolve, reject) => {
      this.auth0.checkSession({}, async (err, authResult) => {
        if (err) {console.log(err); return reject(err)};
         await this.setSession(authResult);
        resolve();
      });
    });
  }
}

const auth0Client = new Auth();

export default auth0Client;